import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SurveyPopupService {
    private _showPopup$ = new BehaviorSubject<boolean>(false);
    public showPopup$ = this._showPopup$.asObservable();

    openPopup() {
        this._showPopup$.next(true);
    }

    closePopup() {
        this._showPopup$.next(false);
    }
}
